import { render, staticRenderFns } from "./GravityWavesViz.vue?vue&type=template&id=3f6d2b21&scoped=true"
import script from "./GravityWavesViz.vue?vue&type=script&lang=js"
export * from "./GravityWavesViz.vue?vue&type=script&lang=js"
import style0 from "./GravityWavesViz.vue?vue&type=style&index=0&id=3f6d2b21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d2b21",
  null
  
)

export default component.exports